import { client } from "../../../api/client";

export const addModuleRevisionLookupItem = async (moduleRevisionId, itemLookupId) => {
    var moduleRevisionLookupItem = {
        moduleRevisionId: moduleRevisionId,
        itemLookupId: itemLookupId,
		disabled: false
    }

    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "Module Revision Lookup Item created successfully", moduleRevisionLookupItem: moduleRevisionLookupItem }
    } else {
        try {
          const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/modulerevisionlookupitem", moduleRevisionLookupItem);
          return response.data;
        } catch (error) {
            console.error("Error creating module revision lookup item:", error);
            return { message: "error:" + error, moduleRevisionLookupItem: null }
        }
    }
}

export const getModuleRevisionLookupItems = async (moduleRevisionId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return []
    } else {
        try {
          const response = await client.get(process.env.REACT_APP_GATEWAY_URI,`iquoteapi/modulerevisionlookupitem/getbymodulerevisionid/${moduleRevisionId}`);
          return response.data;
        } catch (error) {
            console.error("Error reading module revision lookup items:", error);
            return []
        }
    }
}

export const addModuleRevisionLookupItems = async (moduleRevisionId, itemLookupIds) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "Module Revision Lookup Item created successfully", items: [] }
    } else {
        try {
          const response = await client.post(process.env.REACT_APP_GATEWAY_URI,`iquoteapi/modulerevisionlookupitem/${moduleRevisionId}/BulkCreate`, itemLookupIds);
          return response.data;
        } catch (error) {
            console.error("Error creating module revision lookup items:", error);
            return { message: "error:" + error, items: [] }
        }
    }
}

export const removeModuleRevisionLookupItem = async (moduleRevisionLookupItemId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "success" }
    } else {
        try {
          const response = await client.delete(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/modulerevisionlookupitem/" + moduleRevisionLookupItemId);
          return { message: "success" }
        } catch (error) {
            console.error("Error creating module revision lookup item:", error);
            return { message: "error:" + error, moduleRevision: null }
        }
      }
}



